function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

!customElements.get('flex-intel') && customElements.define('flex-intel', 
    class FlexIntel extends HTMLElement {
        FLEX_MAP = {
            Male: {
                G: { min: 50, max: 55 },
                B: { min: 55, max: 60 },
                R: { min: 60, max: 70 },
                S: { min: 70, max: 80 },
                P: { min: 80, max: Infinity }
            },
            Female: {
                G: { min: 35, max: 42.5 },
                B: { min: 42.5, max: 50 },
                R: { min: 50, max: 60 },
                S: { min: 60, max: 70 },
                P: { min: 70, max: Infinity }
            }
        }

        static get observedAttributes() {
            return ['invalid', 'relevant-intel']
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'relevant-intel') { 
                if (newValue) { 
                    const { gender, weight } = JSON.parse(newValue)
                    const flexOption = this.getFlex(gender, weight)  
                    if (flexOption) {
                        this.flexOptionElement.querySelector(`input[value="${flexOption}"]`).checked = true
                        this.flexOptionElement.dispatchEvent(new Event('change', { bubbles: true }))
                    }  
                }
            }
        }

        connectedCallback() { 
            this.submitButton.addEventListener('click', this.boundSubmitHandler)
        } 

         get relevantIntel() {
            return this.getAttribute('relevant-intel')
        }

        set relevantIntel(val) {
            this.setAttribute('relevant-intel', val)
        }

        constructor() {
            super(); 
            this.product = this.closest('original-product')
            this.errorWrapper = this.querySelector('.js-flex-intel-errors')
            this.invalidFields = []
            this.weightInput = this.querySelector('#Weight')
            this.agePicker = this.querySelector('date-picker')
            this.levelInput = this.querySelector('#Level')
            this.genderDropdown = this.querySelector('#GenderDropdown')
            this.genderInput = this.querySelector('#Gender')
            this.submitButton = this.querySelector('.flex-intel-submit')
            this.boundSubmitHandler = this.handleSubmit.bind(this)
            this.intelData = {}

            this.genderDropdown.additionalCallback = (value, instance) => { 
                this.weightInput.setAttribute('data-min', this.weightInput.getAttribute('data-min-' + value.toLowerCase())) 
            } 
            this.flexOptionElement = this.closest('original-product')?.querySelector('.o-product-variant-select[name="keilcode"]') 
        }  

        handleSubmit() {
            this.validateInputs()
            if (!this.hasAttribute('invalid')) {
                this.onSuccess()
            } else {
                this.scrollIntoView({behavior: 'smooth'})
            }
        }

        getFlex(gender, kg) {
            const ranges = this.FLEX_MAP[gender]

            for (const flex in ranges) {
                const { min, max } = ranges[flex]

                if (kg >= min && kg < max) {
                return flex
                }
            }

            return null
        }

        renderError(type = 'input') {   
            let errorString;
            if (type === 'input') {
                errorString = window.flexIntelStrings.error 
                this.errorWrapper.innerHTML = `
                    <p>${errorString}</p>
                    <ul>
                        ${this.invalidFields.map(field => 
                            `<li>${window.flexIntelStrings[field.toLowerCase()]}</li> `
                        ).join('')}
                    </ul>
                `
            } else {
                errorString = window.flexIntelStrings.error_cart
                this.errorWrapper.innerHTML = `
                <p class="cart-error">${errorString}</p>`
            }
        }

        removeError() {
            this.errorWrapper.innerHTML = ''
        }  

        onSuccess() {
            this.relevantIntel = JSON.stringify({
                weight: this.weightInput.value,
                gender: this.genderDropdown.getAttribute('current-value'),
            })
            this.successMessage = document.createElement('p')
            this.successMessage.classList = 'flex-intel-success'
            this.successMessage.textContent = window.flexIntelStrings.success 
            this.submitButton.replaceWith(this.successMessage)
            this.setAttribute('success', '')
        }

        validateInputs() {  
            if (this.genderInput.value?.length > 0) {
                this.invalidFields = this.invalidFields.filter(field => field !== this.genderInput.id)
                this.intelData[this.genderInput.id] = this.genderInput.value  
            } else {
                if (!this.invalidFields.includes(this.genderInput.id)) this.invalidFields.push(this.genderInput.id)
                this.setAttribute('invalid', '')
            }

            this.querySelectorAll('input[type="number"]').forEach(input => {
                const val = +input. value 
                const min = +input.dataset.min 
                const max = +input.dataset.max 
                if (val < min || val > max) {  
                    this.setAttribute('invalid', '') 
                    if (!this.invalidFields.includes(input.id)) this.invalidFields.push(input.id) 
                } else { 
                    this.intelData[input.id] = input.value
                    this.invalidFields = this.invalidFields.filter(field => field !== input.id) 
                }
            })
            
            if (this.agePicker.input.value) {
                this.invalidFields = this.invalidFields.filter(field => field !== this.agePicker.input.id)
                this.intelData[this.agePicker.input.id] = this.agePicker.input.value
            } else {
                this.setAttribute('invalid', '')
                if (!this.invalidFields.includes(this.agePicker.input.id)) this.invalidFields.push(this.agePicker.input.id) 
            }

            if (this.levelInput.value?.length > 0) {
                this.invalidFields = this.invalidFields.filter(field => field !== this.levelInput.id)
                this.intelData[this.levelInput.id] = this.levelInput.value  
            } else {
                if (!this.invalidFields.includes(this.levelInput.id)) this.invalidFields.push(this.levelInput.id)
                this.setAttribute('invalid', '')
            } 
            
            if (this.invalidFields.length > 0) {
                this.intelData = {}
                this.renderError()
            } else { 
                this.removeAttribute('invalid')
                this.removeError()
            }
        }
    }
)